import type { CheckedState } from '../../inputs/CheckBox/CheckBox';
import { CheckBox } from '../../inputs/CheckBox/CheckBox';
import type { HelperText } from '../FormFieldHelperText/FormFieldHelperText';
import {
  getHelperTextProps,
  HelperTextPopover,
} from '../FormFieldHelperText/FormFieldHelperText';

export type CoreFormFieldCheckboxProps = {
  id: string;
  label: React.ReactNode;
  checked?: CheckedState;
  onChange?: (val: CheckedState) => void;
  helperText?: HelperText;
  disabled?: boolean;
  className?: string;
  variant?: 'default' | 'bordered';
};

export function CoreFormFieldCheckbox({
  id,
  label,
  helperText,
  checked,
  onChange = (checked: CheckedState) => {},
  disabled = false,
  className,
  variant = 'default',
}: CoreFormFieldCheckboxProps) {
  const { popoverProps } = getHelperTextProps({
    helperText,
    label,
  });
  const variantClasses =
    variant === 'bordered' ? 'rounded-md border border-gray-300 p-2' : '';

  return (
    <div
      className={`flex items-center gap-2 ${variantClasses} ${className || ''}`}
    >
      <div>
        <CheckBox
          id={id}
          checked={checked}
          onCheckedChange={onChange}
          disabled={disabled}
        />
      </div>
      <label htmlFor={id} className="text-sm font-medium text-gray-700">
        {label}
      </label>
      {popoverProps && <HelperTextPopover {...popoverProps} />}
    </div>
  );
}
